export enum PaymentMethod {
  Disabled = 'Disabled',
  CreditCard = 'CreditCard',
  Ach = 'ACH',
}

export enum CreditCards {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Discover = 'discover',
  Amex = 'amex',
}
